import { Report } from 'features/reporting/types'

import { AssessmentResults } from './sections/AssessmentResults'
import { Cover } from './sections/Cover'
import { PDFGeneration } from './sections/PDFGeneration'
import { ReportReview } from './sections/ReportReview'
import { TableOfContents } from './sections/TableOfContents'

/**
 * FFS (Fitness-For-Service) Report Definition
 *
 * This report generates FFS assessments for RAUT pipe indications.
 *
 * Report Structure:
 * 1. Cover Page - Basic report information and metadata
 * 2. Table of Contents
 * 3. AutoCAD Drawing (Optional) - Drawing of the assessed asset
 * 4. Assessment Results - One section per indication containing:
 *    - Indication Name
 *    - Indication Selection
 *    - FFS Calculation Details (blank for now)
 *    - Conclusion (whether target serviceable date can be reached)
 *    - Assumptions (from ffs-lta-report)
 *    - Recommendations (from ffs-lta-report)
 * 5. Review - Report review and signoff
 * 6. PDF Generation - Generate and download final report
 */
export const ffsReport: Report = {
  coverSection: Cover,
  tocSection: TableOfContents,
  sections: [
    // AutocadDrawing,
    AssessmentResults,
  ],
  reviewSection: ReportReview,
  pdfGenerationSection: PDFGeneration,
  staticSections: [],
}
